import React from "react";

import StaticPageStyles from "./static_pages.module.css"
import RadioButtonCheckedOutlinedIcon from "@mui/icons-material/RadioButtonCheckedOutlined";
import InstagramWarning from "../components/InstagramWarning";

function AboutRecording() {
    return (
        <div className={StaticPageStyles.staticPageContainer}>
            <InstagramWarning/>
            <h1>Детальніше про відео запис гри</h1>

            <h3>У грі є можливість здійснити відеозапис</h3>
            <span className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>
                        Що б увімкнути відеозапис натисніть на <RadioButtonCheckedOutlinedIcon sx={{ color: '#e10000', cursor: "pointer"}} fontSize={"large"}/>
                        в правій верхній частині екрану гри
                    </li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>
                        Відеозапис гри дозволяється тільки зі згоди всіх учасників гри
                    </li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>
                        Ми радимо одразу після увімкнення запису спитати згоди учасників, таким чином їх згода буде зафіксована на відео
                    </li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>
                        Якщо учасник приєднався до гри після того як було увімкнено відеозапис, негайно повідомте йому про те, що ведеться відеозапис та отримайте його згоду
                    </li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>
                        Запис гри ведеться безпосередньо з вашого браузера та мікрофону, нажаль не всі браузери підтримують таку можливість
                    </li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>
                        Браузери що підтримують запис:
                        <ul>
                            <li>
                                <img src={"https://www.google.com/chrome/static/images/chrome-logo.svg"} width={20} height={20} alt={"Chrome"}></img>
                                 <span> Google chrome</span>
                            </li>
                            <li>
                                <img src={"https://upload.wikimedia.org/wikipedia/commons/9/98/Microsoft_Edge_logo_%282019%29.svg"} width={20} height={20} alt={"Microsoft Edge"}></img>
                                <span> MicroSoft Edge</span>
                            </li>

                            <li>
                                <img src={"https://upload.wikimedia.org/wikipedia/commons/2/20/Opera_Touch_icon.svg"} width={20} height={20} alt={"Opera"}></img>
                                <span> Opera*</span>
                            </li>
                        </ul>
                    </li>

                    <br/>
                    <li className={StaticPageStyles.staticPageText}>
                        Нажаль запис на мобільних пристроях Android та iOS через браузер заблоковано розробниками цих операційних систем.
                    </li>

                    <br/>
                    <li className={StaticPageStyles.staticPageText}>
                        Кожен учасник може вести запис незалежно від інших, кожен зі свого браузера відповідно
                    </li>

                    <br/>
                    <li className={StaticPageStyles.staticPageText}>
                        Якщо хоч один учасник веде запис - у всіх учасників відобразиться відповідний червоний індикатор поруч з кнопками керування записом
                    </li>

                </ul>
            </span>

            <h3>Доступ до відеозаписів</h3>
            <span className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Для зручності зберігання та завантаження відеозаписи розбиваються на честини по 40 хвилин</li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>Якщо в процесі гри було здійснено відеозапис - в кабінеті провідника в розділі ігор в розширеному меню з'явиться відповідна секція</li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>Безпосередньо в процесі запису файли зберігаються на сервері в необробленому вигляді, та потребують обробки перед зкачуванням</li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>Якщо до гри є необроблені файли відеозаписів - відповідне повідоблення буде відображено в секції записів, та буде кнопка "Обробити"</li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>Обробка відео на сервері потребує певного часу, поки триває обробка - відповідне повідомлення буде відображено в секції відеозаписів</li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>Обробка відео може тривати від декількох хвилин до декількох годин в залежності від тривалості запису та навантаження на сервер</li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>Якщо після 24 годин відео все ще в статусі "в обробці" - зверніться в службу підтримки</li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>Після завершення обробки вам надійде лист на ваш email, відповідний статус буде відображено в секції відеозаписів, а файли можна буде скачати</li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>Якщо після обробки файлів було здійснено новий запис до гри - обробку файлів треба буде запросити повторно</li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}><b>Файли зберігаються на сервері протягом 30 календарних днів з моменту запису, після чого будуть видалені без можливості відновлення</b></li>

                </ul>
            </span>

            <h3>Відомі проблеми:</h3>
            <span className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}><b>Не працює перемотка відео або відео завмирає</b></li>
                    <ul>
                        <li className={StaticPageStyles.staticPageText}>Якщо при здійсненні запису відбулася зміна розміру вікна гри то це може призводити до проблем відтворення</li>
                        <li className={StaticPageStyles.staticPageText}>Ми наполегливо радимо не змінювати розмір вікна браузера в процесі запису</li>
                        <li className={StaticPageStyles.staticPageText}>Якщо необхідно змінити розмір, наприклад перейти в режим "на весь екран" то зупиніть запис, змініть розмір і почніть запис знову</li>
                        <li className={StaticPageStyles.staticPageText}>Якщо все ж проблема виникла - Скористайтесь альтернативним програвачем</li>
                        <ul>
                            <li className={StaticPageStyles.staticPageText}>(Mac) Elmedia video player (є в App Store)</li>
                            <li className={StaticPageStyles.staticPageText}>(Mac/Windows) VLC</li>
                            <li className={StaticPageStyles.staticPageText}>(Windows) Windows media player legacy (має бути на кожному Windows)</li>
                            <li className={StaticPageStyles.staticPageText}>(Windows) Media player classic - Black Edition (є в Microsoft store під назвою "MPC-BE")</li>
                        </ul>
                    </ul>
                    <br />

                    <li className={StaticPageStyles.staticPageText}><b>Windows media player не може відтворити звук</b></li>
                    <ul>
                        <li className={StaticPageStyles.staticPageText}>В деяких версіях Windows за замовчуванням не встановлено необхідний звуковий кодек (Opus audio codec)</li>
                        <li className={StaticPageStyles.staticPageText}>Скористайтесь альтернативним програвачем</li>
                        <ul>
                            <li className={StaticPageStyles.staticPageText}>Media player classic - Black Edition (є в Microsoft store під назвою "MPC-BE")</li>
                            <li className={StaticPageStyles.staticPageText}>VLC</li>
                            <li className={StaticPageStyles.staticPageText}>Встановіть і налаштуйте набір кодеків K-lite codec pack</li>
                        </ul>
                    </ul>
                    <br />
                    <li className={StaticPageStyles.staticPageText}><b>Інші проблеми з відтворенням відео</b></li>
                    <ul>
                        <li className={StaticPageStyles.staticPageText}>Напишіть нам на support@leelaonline.net</li>
                        <li className={StaticPageStyles.staticPageText}>Ми допоможемо знайти рішення і виправимо проблему або доповнимо цей документ</li>
                    </ul>
                </ul>
            </span>
        </div>
    )
}

export default AboutRecording